import React from "react";
import { AlertTriangle } from "lucide-react";

const ConfirmationDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  heading,
  subHeading,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-sm w-full mx-4 p-6">
        {/* Header with Icon and Title */}
        <div className="flex items-center mb-6">
          <div className="flex-shrink-0 mr-3">
            <AlertTriangle className="h-6 w-6 text-amber-500" />
          </div>
          <h3 className="text-xl font-semibold text-gray-900">{heading}</h3>
        </div>

        {/* Message */}
        <div className="mb-8">
          <p className="text-gray-600 text-sm leading-relaxed">{subHeading}</p>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-3 h-12 font-medium bg-[#F4F9F8] text-[#3C575C] rounded-md hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-3 text-white font-medium shadow-md h-12 bg-[#4c7375] rounded-md hover:bg-teal-800 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
          >
            Yes, Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
